export default "__VITE_ASSET__wmGTHRI___"